import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import Projects from './pages/Projects';
import ProjectDetails from './pages/ProjectDetails';
import Resume from './pages/Resume';
import ScrollToTop from './components/ScrollToTop';
import './styles/global.css';

// Only import Admin in development mode
const Admin = process.env.NODE_ENV === 'development' 
  ? React.lazy(() => import('./pages/Admin'))
  : null;

const App: React.FC = () => {
  return (
    <Router>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/projects" element={<Projects />} />
        <Route path="/projects/:id" element={<ProjectDetails />} />
        <Route path="/resume" element={<Resume />} />
        {/* Admin route - only available in development */}
        {Admin && (
          <Route 
            path="/admin" 
            element={
              <React.Suspense fallback={<div style={{ padding: '2rem', textAlign: 'center' }}>Loading Admin...</div>}>
                <Admin />
              </React.Suspense>
            } 
          />
        )}
      </Routes>
    </Router>
  );
};

export default App;
